import classNames from 'classnames';
import { FunctionComponent } from 'react';

type TextInputProps = {
    id: string;
    setValue: (value: string | undefined) => void;
    placeholder: string;
    value: string;
    disabled?: boolean | undefined;
    hasError?: boolean;
};

export const TextInput: FunctionComponent<TextInputProps> = ({
    id,
    setValue,
    disabled,
    placeholder,
    value,
    hasError,
}) => {
    return (
        <input
            id={id}
            className={classNames('form-control', { 'has-error': hasError })}
            type="text"
            disabled={disabled}
            placeholder={placeholder}
            value={value}
            onChange={(event) => {
                setValue(event.currentTarget.value);
            }}
            onBlur={(event) => {
                setValue(event.currentTarget.value?.trim() || undefined);
            }}
        />
    );
};
